import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CallToActionComponent } from './CallToAction.component';

@NgModule({
    imports: [CommonModule, RouterModule],
    declarations: [CallToActionComponent],
    exports: [CallToActionComponent],
    providers: []
})
export class CallToActionModule {}
